import { useEffect, useRef, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import VisToggle from "@/components/technique/VisToggle";

function AuthImage({ src, onOpen, onDelete, testid, vis }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    let u = "";
    api.get(src, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => {});
    return () => u && URL.revokeObjectURL(u);
  }, [src]);
  return (
    <div className="relative group h-16 w-16 rounded-md overflow-hidden border bg-slate-100" data-testid={testid}>
      {url ? <img src={url} alt="" className="h-full w-full object-cover cursor-zoom-in" onClick={() => onOpen(url)} /> : <Loader2 className="h-4 w-4 m-6 animate-spin text-slate-400" />}
      {onDelete && <button type="button" onClick={onDelete} className="absolute top-0.5 right-0.5 rounded-full bg-white/90 p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"><X className="h-3 w-3 text-rose-600" /></button>}
      {vis}
    </div>
  );
}

export default function PhotoStrip({ kind, entry, reload, tag = "", readOnly }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [zoom, setZoom] = useState("");
  const photos = (entry.photos || []).filter((p) => !tag || p.tag === tag);
  const upload = async (files) => {
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData(); fd.append("file", f);
        await api.post(`/technique/entries/${kind}/${entry.id}/photos${tag ? `?tag=${tag}` : ""}`, fd);
      }
      toast.success("Photo(s) ajoutée(s)"); reload();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const del = async (p) => { await api.delete(`/technique/entries/${kind}/${entry.id}/photos/${p.id}`); reload(); };
  return (
    <div className="flex flex-wrap items-center gap-2">
      {photos.map((p) => <AuthImage key={p.id} src={`/technique/entries/${kind}/${entry.id}/photos/${p.id}`} onOpen={setZoom} onDelete={readOnly ? null : () => del(p)} testid={`photo-${p.id}`}
        vis={<VisToggle small kind="photo" id={entry.id} photoId={p.id} visible={p.visible_client} testid={`photo-vis-${p.id}`} />} />)}
      {!readOnly && <>
        <input ref={ref} type="file" accept="image/*" capture="environment" multiple className="hidden" onChange={(e) => e.target.files.length && upload([...e.target.files])} data-testid={`photo-input-${entry.id}${tag ? `-${tag}` : ""}`} />
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`photo-add-${entry.id}${tag ? `-${tag}` : ""}`}
          className="h-16 w-16 rounded-md border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 hover:border-brand-500 hover:text-brand-600 transition-colors">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Camera className="h-4 w-4" />}<span className="text-[9px] mt-0.5">{tag === "correction" ? "Correction" : "Photo"}</span>
        </button>
      </>}
      {zoom && <div className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4" onClick={() => setZoom("")} data-testid="photo-zoom"><img src={zoom} alt="" className="max-h-full max-w-full rounded-lg" /></div>}
    </div>
  );
}
